import AddressCard from '@/components/general/address-card.vue';
import BarcodeReaderInput from '@/components/fields/barcode-reader-input.vue';
export default {
    components : {
        AddressCard,
        BarcodeReaderInput
    },
    props: {
        summaryData       :  {
            type    : Object,
            default : {}
        },
        jsonDebug   :  {
            type    : Boolean,
            default : true
        },
    },
    data: () => ({
        panels                      : [0, 1, 2, 3, 4, 5],
        panelStepProductData        : null,
        panelStepProductWarranty    : null,
        panelStepProductDefect      : null,
        panelStepProductReplacement : null,
        panelStepCustomerData       : null,
        panelOrderInformations      : null,

        selectTransport             : 'GLECLERC',
        productTransportOptions     : [
            {
                id      : 'GLECLERC'
            },
            {
                id      : 'OTHER'
            }
        ],
        numTransportParts           : null,

    }),
    methods : {
        validateAll() {
            console.info('on validate product defect js');
            // this.$v.stepProductDefect.$touch();
            // if (this.$v.stepProductDefect.$anyError) {
            //     return false;
            // } else {
            //     return true;
            // }
        },
        validateStep() {
            // if(!this.$v.stepProductDefect.$dirty) {
            //     return;
            // } else {
            //     this.$v.stepProductDefect.$touch();
            // }
        },
        getStepData() {
            let ret = {};


            // ret.originalSymptomCodes = this.symptomCodes;
            // ret.original conditionCodes SymptomCodes = this.symptomCodes;
            return ret;
        },
        getStepSubmitData() {
            console.info('getStepSubmitData');
            let ret = {};

            //Transport
            ret.transportCompany    = this.selectTransport;
            ret.numberOfParts       = this.numTransportParts;

            //barcode
            ret.orderReference      = "9499999978";
            ret.orderReferenceNone  = false;

            ret.description      = this.inputOtherDefects;

            return ret;
        }


    }
};
